import { Component, OnInit, OnChanges } from '@angular/core';
import { LoggerService } from 'src/shared/logger/logger.service';
import { Levels } from 'src/shared/logger/levels.enum';
import { HomeService } from '../shared/home.service';
import { MatDialog } from '@angular/material/dialog';
import { DialogMonitorProvisionComponent } from '../quick-actions/dialog-monitor-provision/dialog-monitor-provision.component';
import { AccessAuthService } from 'src/shared/access.auth.service';

@Component({
  selector: 'app-provisioned-units-graph',
  templateUrl: './provision-units-graph.component.html',
  styleUrls: ['./provision-units-graph.component.css']
})
export class ProvisionUnitsGraphComponent implements OnInit {
  public doughnutChartLabels: string[] = ["Provisioned Units", "UnProvisioned Units"];
  public doughnutChartOptions = {
    borderWidth: 1,
    maintainAspectRatio: false
  };
  public doughnutChartData: number[] = [];
  public doughnutChartType = 'doughnut';
  public doughnutChartLegend = true;
  user_info_obj: any;
  adminAuthorization: boolean = false;

  constructor(private loggerService: LoggerService,
    private homeService: HomeService,
    public dialog: MatDialog,
    public accessAuthService: AccessAuthService) {
  }

  ngOnInit(): void {
    this.accessAuthService.isAdmin.subscribe(data => this.adminAuthorization = data)

    this.homeService.dataToBeTransmitted.subscribe(data => {
      this.doughnutChartData = [];
      data?.provisionedUnits.forEach(i => this.doughnutChartData.push(i.count))
      data?.unprovisionedUnits.forEach(i => this.doughnutChartData.push(i.count))
    })
  }


  openUnProvisionDIalog() {
    const dialogRef = this.dialog.open(DialogMonitorProvisionComponent, {
      minWidth: '95vw',
      maxWidth: '95vw',
      minHeight: '50%',
      data: "Provision",
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      this.homeService.getVMSStatistics().subscribe(data => {
        this.homeService.dataToBeTransmitted.next(data.data);
      }, err => {
        this.loggerService.log("ProvisionUnitsGraphComponent", err.error.message ? err.error.message : "Error while sending data", Levels.error)
      })
    });

  }

  openProvisionDIalog() {
    const dialogRef = this.dialog.open(DialogMonitorProvisionComponent, {
      minWidth: '95vw',
      maxWidth: '95vw',
      minHeight: '50%',
      data: "UnProvision",
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      this.homeService.getVMSStatistics().subscribe(data => {
        this.homeService.dataToBeTransmitted.next(data.data);
      }, err => {
        this.loggerService.log("ProvisionUnitsGraphComponent", err.error.message ? err.error.message : "Error while sending data", Levels.error)
      })
    });
  }
}
